class SearchStringOrIntReq {
    constructor(){
        this.searchString = undefined;
        this.searchInt = undefined;
        this.searchDate = undefined;
        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        }
    }
}

export default SearchStringOrIntReq;